/**
 * Community (bbPress) detail page interactions:
 * - tag chip input for the Create New Post modal
 * - description character counter
 * - report modal (UI only, no persistence)
 * - decorative EN/AR pill toggle
 * - share icon (copy link to clipboard)
 * - topic likes (AJAX toggle, per-user)
 */
(function ($) {
  'use strict';

  function initTagChipInput() {
    var wrapper = document.querySelector('[data-tag-chip-input]');
    if (!wrapper) return;

    var container = wrapper;
    var list = wrapper.querySelector('.tag-chip-list');
    var input = wrapper.querySelector('.tag-chip-text-input');
    var hidden = document.getElementById('bbp_topic_tags');
    var formGroup = input.closest('.form-group');

    function updateFloatingLabel() {
      if (!formGroup) return;

      if (tags.length > 0 || document.activeElement === input) {
        formGroup.classList.add('focused');
      } else {
        formGroup.classList.remove('focused');
      }
    }
    if (!list || !input || !hidden) return;

    var tags = [];

    function sync() {
      hidden.value = tags.join(',');
    }

    function render() {
      list.innerHTML = '';

      tags.forEach(function (tag, index) {
        var chip = document.createElement('span');
        chip.className = 'tag-chip';
        chip.textContent = tag;

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'tag-chip-remove';
        remove.setAttribute('aria-label', 'Remove tag');
        remove.innerHTML = '<i class="icon icon--small icon-cross"></i>';

        remove.addEventListener('click', function () {
          tags.splice(index, 1);
          render();
          sync();

          input.focus();
        });

        chip.appendChild(remove);
        list.appendChild(chip);
      });

      updateFloatingLabel();
    }

    function addTag(raw) {
      var value = raw.trim();

      if (!value) return;

      if (tags.indexOf(value) === -1) {
        tags.push(value);
        render();
        sync();

        updateFloatingLabel();
      }
    }

    // Seed from any existing value (e.g. a previously failed submit)
    if (hidden.value) {
      hidden.value.split(',').forEach(function (value) {
        if (value.trim()) tags.push(value.trim());
      });
      render();
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ',') {
        e.preventDefault();

        addTag(input.value);
        input.value = '';

        requestAnimationFrame(function () {
          input.focus();
        });
      } else if (e.key === 'Backspace' && !input.value && tags.length) {
        tags.pop();
        render();
        sync();
      }
    });

    input.addEventListener('blur', function () {
      if (input.value) {
        addTag(input.value);
        input.value = '';
      }

      setTimeout(updateFloatingLabel, 0);
    });
    input.addEventListener('focus', function () {
      updateFloatingLabel();
    });
  }

  function initCharCounter() {
    var counter = document.querySelector('[data-char-counter]');
    var textarea = document.getElementById('bbp_topic_content');
    if (!counter || !textarea) return;

    var max = parseInt(counter.getAttribute('data-max'), 10) || 300;
    textarea.setAttribute('maxlength', max);

    function update() {
      counter.textContent = textarea.value.length + '/' + max;
    }

    textarea.addEventListener('input', update);
    update();
  }

  function initReportModal() {
    var modal = document.getElementById('reportPostModal');
    if (!modal) return;

    var form = modal.querySelector('[data-report-post-form]');
    var thanks = modal.querySelector('[data-report-thanks]');
    var submitBtn = modal.querySelector('[data-report-submit]');

    modal.addEventListener('show.bs.modal', function (event) {
      // Reset state each time the modal opens BEFORE setting hidden values
      form.reset();
      thanks.hidden = true;
      form.querySelectorAll('.report-modal-reasons, .form-group').forEach(function (el) {
        el.hidden = false;
      });
      submitBtn.disabled = false;

      var trigger = event.relatedTarget;
      var topicId = null;
      if (trigger) {
        topicId = trigger.getAttribute('data-topic-id') || trigger.getAttribute('data-post-id');
      }
      var replyId = null;
      if (trigger) {
        replyId = trigger.getAttribute('data-reply-id');
      }
      var contentType = 'topic';
      if (replyId) {
        contentType = 'reply';
      }
      var objectId = replyId || topicId || '';

      var objectIdInput = form.querySelector('#report_object_id');
      var contentTypeInput = form.querySelector('#report_content_type');
      if (objectIdInput) objectIdInput.value = objectId;
      if (contentTypeInput) contentTypeInput.value = contentType;

      form.setAttribute('data-topic-id', objectId);
      form.setAttribute('data-content-type', contentType);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var reasonChosen = form.querySelector('input[name="report_reason"]:checked');
      if (!reasonChosen) {
        form.querySelector('.report-modal-reasons').classList.add('is-invalid');
        return;
      }

      submitBtn.disabled = true;

      var objectIdInput = form.querySelector('#report_object_id');
      var contentTypeInput = form.querySelector('#report_content_type');
      var objectId = form.getAttribute('data-topic-id');
      if (objectIdInput && objectIdInput.value) {
        objectId = objectIdInput.value;
      }

      var contentType = form.getAttribute('data-content-type') || 'topic';
      if (contentTypeInput && contentTypeInput.value) {
        contentType = contentTypeInput.value;
      }

      var comments = '';
      var commentsEl = form.querySelector('textarea[name="report_comments"]');
      if (commentsEl) {
        comments = commentsEl.value;
      }

      var payload = {
        object_id: Number(objectId),
        content_type: contentType,
        report_reason: reasonChosen.value,
        report_comments: comments
      };

      var homeUrl = '';
      if (window.ajax_callback_data && window.ajax_callback_data.home_url) {
        homeUrl = window.ajax_callback_data.home_url.replace(/\/+$/, '');
      }

      var restEndpoint = '/wp-json/diversabilities/v1/moderation/report';
      if (homeUrl) {
        restEndpoint = homeUrl + '/wp-json/diversabilities/v1/moderation/report';
      }
      if (window.dvModeration && window.dvModeration.restUrl) {
        restEndpoint = window.dvModeration.restUrl + 'report';
      }

      try {
        var urlObj = new URL(restEndpoint, window.location.href);
        if (urlObj.origin !== window.location.origin) {
          restEndpoint = urlObj.pathname + urlObj.search;
        }
      } catch (err) {}

      var nonce = '';
      if (window.ajax_callback_data && window.ajax_callback_data.ajax_nonce) {
        nonce = window.ajax_callback_data.ajax_nonce;
      }
      if (window.dvModeration && window.dvModeration.nonce) {
        nonce = window.dvModeration.nonce;
      }

      fetch(restEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': nonce
        },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        return res.json().catch(function() {
          throw new Error('Server response was not valid JSON.');
        });
      })
      .then(function (data) {
        if (data.status === true || data.status === 'success') {
          form.querySelectorAll('.report-modal-reasons, .form-group').forEach(function (el) {
            el.hidden = true;
          });
          thanks.textContent = data.message || 'Thank you — your report has been received.';
          thanks.hidden = false;

          setTimeout(function () {
            if (window.bootstrap) {
              var bsModal = bootstrap.Modal.getInstance(modal);
              if (bsModal) {
                bsModal.hide();
              }
            } else if (window.jQuery) {
              $(modal).modal('hide');
            }
          }, 2000);
        } else {
          alert(data.message || 'Error submitting report.');
          submitBtn.disabled = false;
        }
      })
      .catch(function (err) {
        var errMsg = 'An error occurred while submitting your report. Please try again.';
        if (err && err.message) {
          errMsg = err.message;
        }
        alert(errMsg);
        submitBtn.disabled = false;
      });
    });
  }

  function initPostFeedLangToggle() {
    // Handled by original-language-switch.js when data-original-toggle is present.
    var pill = document.querySelector('.post-feed-header .original-lang-switch');
    if (!pill || pill.hasAttribute('data-original-toggle')) return;

    var options = pill.querySelectorAll('.lang-option');

    pill.addEventListener('click', function (e) {
      var btn = e.target.closest('.lang-option');
      if (!btn) return;

      options.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    });
  }

  function initShareButtons() {
    document.querySelectorAll('[data-share-url]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-share-url');
        if (!url || !navigator.clipboard) return;

        navigator.clipboard.writeText(url).then(function () {
          btn.classList.add('copied');
          setTimeout(function () {
            btn.classList.remove('copied');
          }, 1500);
        }).catch(function () {
          // Clipboard unavailable — fail silently, nothing else to do here.
        });
      });
    });
  }

  // Comments section: nested replies start collapsed behind a "View N more
  // replies" toggle (per bbp-threaded-replies list, at every depth); clicking
  // it expands that list and swaps the toggle to "Hide". UI-only — nothing is
  // persisted, so the state resets on reload, same as the report modal above.
  function initThreadedReplyToggles() {
    document.querySelectorAll('.bbp-reply-toggle-children').forEach(function (toggle) {
      var replyRoot = toggle.closest('[id^="post-"]');
      var childList = null;
      if (replyRoot) {
        childList = replyRoot.nextElementSibling;
      }

      if (!childList || !childList.classList.contains('bbp-threaded-replies')) return;

      var count = childList.querySelectorAll('li').length;
      if (!count) return;

      childList.classList.add('is-collapsed');
      toggle.hidden = false;

      function render() {
        var collapsed = childList.classList.contains('is-collapsed');
        if (collapsed) {
          var replyWord = 'replies';
          if (count === 1) {
            replyWord = 'reply';
          }
          toggle.textContent = 'View ' + count + ' more ' + replyWord;
        } else {
          toggle.textContent = 'Hide';
        }
      }

      toggle.addEventListener('click', function () {
        childList.classList.toggle('is-collapsed');
        render();
      });

      render();
    });
  }

  function initTopicLikes() {
    $(document).on('click', 'button.post-feed-card-likes', function (e) {
      e.preventDefault();

      var btn = $(this);
      if (btn.data('liking')) return;

      var topicId = btn.data('topic-id');
      if (!topicId) return;

      if (!window.ajax_callback_data || !ajax_callback_data.is_logged_in) {
        if (window.ajax_callback_data && ajax_callback_data.login_url) {
          window.location.href = ajax_callback_data.login_url;
        }
        return;
      }

      btn.data('liking', true);

      $.post(
        ajax_callback_data.ajax_url,
        {
          action: 'qcs_toggle_topic_like',
          topic_id: topicId,
          nonce: ajax_callback_data.ajax_nonce,
        },
        function (response) {
          if (response.success) {
            var liked = response.data.status === 'liked';
            btn.toggleClass('is-liked', liked);
            if (liked) {
              btn.attr('aria-pressed', 'true');
            } else {
              btn.attr('aria-pressed', 'false');
            }
            btn.find('.icon').toggleClass('icon-like-filled', liked).toggleClass('icon-like', !liked);
            btn.find('.post-feed-card-likes-count').text(response.data.count);
          } else {
            console.error('AJAX error:', response.data);
          }
        }
      ).fail(function (xhr) {
        console.error('AJAX request failed:', xhr.responseText);
      }).always(function () {
        btn.data('liking', false);
      });
    });
  }

  function initForumJoin() {
    $(document).on('click', '.forum-card-join', function (e) {
      e.preventDefault();

      var btn = $(this);
      if (btn.data('joining')) return;

      var forumId = btn.data('forum-id');
      if (!forumId) return;

      if (!window.ajax_callback_data || !ajax_callback_data.is_logged_in) {
        if (window.ajax_callback_data && ajax_callback_data.login_url) {
          window.location.href = ajax_callback_data.login_url;
        }
        return;
      }

      var wasJoined = btn.hasClass('is-joined');
      var optimisticJoined = !wasJoined;
      var optimisticLabel = btn.data('join-label') || 'Join Community';
      if (optimisticJoined) {
        optimisticLabel = btn.data('leave-label') || 'Leave Community';
      }

      btn.data('joining', true);
      btn.toggleClass('is-joined', optimisticJoined);
      btn.toggleClass('btn-primary', optimisticJoined);
      btn.toggleClass('btn-outline-primary', !optimisticJoined);
      btn.find('span').text(optimisticLabel);

      $.post(
        ajax_callback_data.ajax_url,
        {
          action: 'qcs_toggle_forum_join',
          forum_id: forumId,
          nonce: ajax_callback_data.ajax_nonce,
        },
        function (response) {
          if (response.success) {
            var joined = response.data.status === 'joined';
            var joinLabel = btn.data('join-label') || 'Join Community';
            var leaveLabel = btn.data('leave-label') || 'Leave Community';

            // A forum can appear more than once (for example, in search
            // results). Keep every visible instance in sync with the API.
            $('.forum-card-join').filter(function () {
              return String($(this).data('forum-id')) === String(forumId);
            }).each(function () {
              var forumButton = $(this);
              forumButton.toggleClass('is-joined', joined);
              forumButton.toggleClass('btn-primary', joined);
              forumButton.toggleClass('btn-outline-primary', !joined);
              var btnLabel = forumButton.data('join-label') || joinLabel;
              if (joined) {
                btnLabel = forumButton.data('leave-label') || leaveLabel;
              }
              forumButton.find('span').text(btnLabel);
            });

            $('.forum-card-members-count').each(function () {
              var count = $(this);
              var card = count.closest('.forum-card');
              var countForumId = count.closest('[data-forum-id]').data('forum-id');
              if (card.length) {
                countForumId = card.find('.forum-card-join').first().data('forum-id');
              }
              if (String(countForumId) === String(forumId)) {
                count.text(response.data.member_count);
              }
            });

            $('.community-create-post').filter(function () {
              return String($(this).data('forum-id')) === String(forumId);
            }).prop('hidden', !joined);
          } else {
            console.error('AJAX error:', response.data);
          }
        }
      ).fail(function (xhr) {
        console.error('AJAX request failed:', xhr.responseText);
        // Restore the prior state if the membership request could not be saved.
        btn.toggleClass('is-joined', wasJoined);
        btn.toggleClass('btn-primary', wasJoined);
        btn.toggleClass('btn-outline-primary', !wasJoined);
        var rollbackLabel = btn.data('join-label') || 'Join Community';
        if (wasJoined) {
          rollbackLabel = btn.data('leave-label') || 'Leave Community';
        }
        btn.find('span').text(rollbackLabel);
      }).always(function () {
        btn.data('joining', false);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTagChipInput();
    initCharCounter();
    initReportModal();
    initPostFeedLangToggle();
    initShareButtons();
    initThreadedReplyToggles();
    initTopicLikes();
    initForumJoin();
  });
})(jQuery);
